<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Antonina Irena Brzozowska was born and educated in the north-east of England.</p><br/>
<p style="text-align: center;">A former teacher, her interests incorporate the Polish, Canadian, and Hawaiian cultures and traditions.</p><br/>
<p style="text-align: center;">Her extensive travel experiences in these countries have provided her with an invaluable asset to her writing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?78d2bd38